// Etichette localizzate per gli scontrini-tessera (carte fedeltà e buoni regalo).
// La lingua è configurabile nelle Impostazioni di stampa (predefinita: spagnolo).

const LABELS = {
  es: {
    loyaltyTitle: 'Tarjeta de Fidelidad',
    points: 'Puntos acumulados',
    loyaltyHint: 'Escanea para ver tus puntos',
    giftTitle: 'Tarjeta Regalo',
    balance: 'Saldo disponible',
    giftHint: 'Escanea para ver el saldo',
    forPrefix: 'Para',
  },
  it: {
    loyaltyTitle: 'Tessera Fedeltà',
    points: 'Punti accumulati',
    loyaltyHint: 'Inquadra per vedere i tuoi punti',
    giftTitle: 'Buono Regalo',
    balance: 'Saldo disponibile',
    giftHint: 'Inquadra per vedere il saldo',
    forPrefix: 'Per',
  },
  en: {
    loyaltyTitle: 'Loyalty Card',
    points: 'Points earned',
    loyaltyHint: 'Scan to view your points',
    giftTitle: 'Gift Card',
    balance: 'Available balance',
    giftHint: 'Scan to view the balance',
    forPrefix: 'For',
  },
  fr: {
    loyaltyTitle: 'Carte de Fidélité',
    points: 'Points cumulés',
    loyaltyHint: 'Scannez pour voir vos points',
    giftTitle: 'Carte Cadeau',
    balance: 'Solde disponible',
    giftHint: 'Scannez pour voir le solde',
    forPrefix: 'Pour',
  },
  pt: {
    loyaltyTitle: 'Cartão Fidelidade',
    points: 'Pontos acumulados',
    loyaltyHint: 'Digitalize para ver os seus pontos',
    giftTitle: 'Cartão-Presente',
    balance: 'Saldo disponível',
    giftHint: 'Digitalize para ver o saldo',
    forPrefix: 'Para',
  },
};

export const CARD_LANGUAGES = [
  { code: 'es', label: 'Español' },
  { code: 'it', label: 'Italiano' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'pt', label: 'Português' },
];

export const cardLabels = (lang) => LABELS[String(lang || 'es').toLowerCase()] || LABELS.es;
